import TabPanel from '@shared/Presentation/components/common/TabPanel'

const Home = () => {
  return (
    <TabPanel />
  )
}

export default Home